import { Row } from 'antd'
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint'
import Steps from 'app/components/Core/MachineGroup/MachineInteraction/Steps'
import Container from 'app/components/UI-Elements/Layout/Container'
import KCol from 'app/components/UI-Elements/Layout/KCol'
import KFooter from 'app/components/UI-Elements/Layout/KFooter'
import useTitle from 'app/lib/hooks/useTitle'
import { PageProps } from 'app/pages/typing'
import React from 'react'
import { useState } from 'react'
import { useParams } from 'react-router-dom'

const portalId = 'transactional-machine-interaction-footer'

const View: React.FC<PageProps> = (props) => {
  const { title: pageTitle } = useTitle(props)
  const { transactional_id } = useParams<{ transactional_id: string }>()
  const [title, setTitle] = useState<string>(pageTitle)
  const [subtitle, setSubtitle] = useState<string>(null)
  const { md } = useBreakpoint()

  return (
    <Container card={false}>
      <Row justify="center">
        <KCol xs={24} md={20} lg={12} card title={title || pageTitle} subtitle={subtitle}>
          <Steps
            rental_id={transactional_id}
            portalId={portalId}
            setTitle={setTitle}
            setSubtitle={setSubtitle}
          />
          <KFooter sticky={!md} removePadding={md} id={portalId}></KFooter>
        </KCol>
      </Row>
    </Container>
  )
}

export default View
